// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dcf6d619","453":"ed978119","667":"f7ec8420"}[chunkId] + ".chunk.js";
};